(function(){
  var sections = document.querySelectorAll('.hcards');
  if (!sections.length) return;

  sections.forEach(function(root){
    var rail = root.querySelector('.hcards__rail');
    if (!rail) return;

    var prev = root.querySelector('.hcards__arrow--prev');
    var next = root.querySelector('.hcards__arrow--next');

    function step(){
      var card = rail.querySelector('.hcards__card');
      var gap = parseFloat(getComputedStyle(rail).gap) || 16;
      return ((card && card.getBoundingClientRect().width) || 300) + gap;
    }

    function updateArrows(){
      if (!prev || !next) return;
      var atStart = rail.scrollLeft <= 1;
      var atEnd = Math.ceil(rail.scrollLeft + rail.clientWidth) >= (rail.scrollWidth - 1);
      prev.classList.toggle('is-disabled', atStart);
      next.classList.toggle('is-disabled', atEnd);
    }

    if (prev) prev.addEventListener('click', function(){
      rail.scrollBy({ left: -step(), behavior: 'smooth' });
      // small delay so scrollLeft updates before we compute
      setTimeout(updateArrows, 150);
    });

    if (next) next.addEventListener('click', function(){
      rail.scrollBy({ left:  step(), behavior: 'smooth' });
      setTimeout(updateArrows, 150);
    });

    rail.addEventListener('scroll', updateArrows, { passive: true });

    // initialize on load
    updateArrows();
  });
})();
